import { useContext, useEffect, useRef } from 'react'

import { InstallAppContext } from '@app/context'
import { PosthogEvent } from '@app/constants'
import { captureAnalytics } from '@app/helpers/misc'

export const useInstallPrompt = (storageKey?: string) => {
  const { event: installEvent, setEvent } = useContext(InstallAppContext)

  const hasPrompted = useRef(false)

  const installApp = async () => {
    if (!installEvent) return

    try {
      await installEvent.prompt()

      const { outcome } = await installEvent.userChoice

      if (outcome === 'accepted') {
        captureAnalytics(PosthogEvent.APP_INSTALLED, {})
      }

      setEvent(null)
    } catch (e) {
      console.error(e)
    }
  }

  useEffect(() => {
    if (!installEvent) return
    if (hasPrompted.current) return

    if (storageKey) {
      const shouldPrompt =
        sessionStorage.getItem(storageKey) === 'true'

      if (!shouldPrompt) return

      sessionStorage.removeItem(storageKey)
    }

    hasPrompted.current = true
    void installApp()
  }, [installEvent, storageKey])
}
